import React from 'react';
import { Button, Box, Typography } from '@mui/material';
import ArrowForwardRoundedIcon from '@mui/icons-material/ArrowForwardRounded';
import ArrowBackRoundedIcon from '@mui/icons-material/ArrowBackRounded';
import PropTypes from 'prop-types';

const PinkGradientButtonWithArrow = ({
    label,
    onClick,
    sx = {},
    arrowPosition = 'right', // 'right' or 'left'
}) => {
    const ArrowIcon = arrowPosition === 'left' ? ArrowBackRoundedIcon : ArrowForwardRoundedIcon;

    return (
        <Button
            onClick={onClick}
            sx={{
                background: '#FF669B',
                color: 'white',
                borderRadius: '36px',
                height: '68px',
                width: '100%',
                maxWidth: '333px',
                textTransform: 'none',
                fontFamily: 'Inter',
                fontWeight: 500,
                fontSize: '20px',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'flex-start',
                pl: arrowPosition === 'left' ? '70px' : '25px',
                pr: arrowPosition === 'right' ? '70px' : '25px',
                position: 'relative',
                transition: 'none',
                '&:hover': {
                    background: '#FF669B', // No change on hover
                    color: 'white',
                    boxShadow: 'none',
                },
                ...sx,
            }}
        >
            {/* Arrow on the left */}
            {arrowPosition === 'left' && (
                <Box
                    sx={{
                        position: 'absolute',
                        left: '8px',
                        top: '50%',
                        transform: 'translateY(-50%)',
                        backgroundColor: 'white',
                        borderRadius: '50%',
                        width: '50px',
                        height: '50px',
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                    }}
                >
                    <ArrowIcon sx={{ color: '#BD8DE8', fontSize: '24px' }} />
                </Box>
            )}

            {/* Label */}
            <Typography
                variant="inherit"
                sx={{
                    fontSize: sx.fontSize || '20px',
                    fontWeight: 500,
                    whiteSpace: 'nowrap',
                }}
            >
                {label}
            </Typography>

            {/* Arrow on the right */}
            {arrowPosition === 'right' && (
                <Box
                    sx={{
                        position: 'absolute',
                        right: '8px',
                        top: '50%',
                        transform: 'translateY(-50%)',
                        backgroundColor: 'white',
                        borderRadius: '50%',
                        width: '50px',
                        height: '50px',
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                    }}
                >
                    <ArrowIcon sx={{ color: '#BD8DE8', fontSize: '24px' }} />
                </Box>
            )}
        </Button>
    );
};

PinkGradientButtonWithArrow.propTypes = {
    label: PropTypes.string.isRequired,
    onClick: PropTypes.func.isRequired,
    sx: PropTypes.object,
    arrowPosition: PropTypes.oneOf(['left', 'right']),
};

export default PinkGradientButtonWithArrow;
